document.addEventListener('DOMContentLoaded', () => {


  if (document.querySelector('#prod-sub-form')) {
    // Get all attribute values 

    [...document.querySelectorAll('select')].filter(el => {
      if (el.getAttribute('name').startsWith('attribute')) {
        const newField = '<input type="hidden" value="' + el.value + '" name="' + el.getAttribute('name') + '" />';

        document.querySelector('#subscription_form').innerHTML += newField;

        el.addEventListener('change', () => {
          document.querySelector('#subscription_form').querySelector('[name="' + el.getAttribute('name') + '"]').value = el.value;
        })
      }
    });

    if (document.querySelector('.variation_id')) {
      const originalSelector = document.querySelector('.variation_id');

      const newVariationField = '<input type="hidden" value="' + originalSelector.value + '" name="variation_id" />';

      document.querySelector('#subscription_form').innerHTML += newVariationField;

      $( '.single_variation_wrap' ).on( 'show_variation', function( event, variation) {

        console.log(variation.variation_id)

        document.querySelector('#subscription_form').querySelector('[name="variation_id"]').setAttribute('value', variation.variation_id);
      });

    }

    document.querySelector('.subscription-select').addEventListener('change', (el) => {
      console.log('Element ', el);

      document.querySelector('.sub-period-field').value = el.target.value;
    })

  }
})